<!-- 执行情况 -->
<template>
  <a-card size="small" title="CI执行情况" :bordered="true" style="border: 1px solid #ccc; padding: 10px; border-radius: 4px;">
    <div v-if="filterForm" :id="id" :style="{ height: height, width: width }">
      <a-row :gutter="16">
        <a-col class="customer-col" :span="8">
          <ci-execute-num-charts
            v-if="executeDatas"
            ref="CiExecuteNumCharts"
            :filter-form="filterForm"
            :execute-items="executeDatas"
          />
        </a-col>
        <a v-for="executeData in executeDatas" :key="executeData.team_id">
          <a-col class="customer-col" :span="8">
            <ci-execute-charts
              v-if="executeDatas"
              ref="CiExecuteCharts"
              :filter-form="filterForm"
              :team-name="executeData.team_name"
              :success="executeData.success_count"
              :failed="executeData.fail_count"
              :skip="executeData.skip_count"
              :no-run="executeData.not_run_count"
              :total="executeData.total_count"
              :fail-gitlab-url="executeData.fail_gitlab_url"
              :chart-id="'chart-' + executeData.team_id"
            />
          </a-col>
        </a>
      </a-row>
    </div>
  </a-card>
</template>

<script>
import { getCiExecuteData } from '@/api/data/quality';
import CiExecuteCharts from '@/pages/data/ciexecute/components/CiExecuteCharts.vue';
import CiExecuteNumCharts from '@/pages/data/ciexecute/components/CiExecuteNumCharts.vue';

export default {
  components: { CiExecuteCharts, CiExecuteNumCharts },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      id: 'ci-execute',
      executeDatas: null
    };
  },
  watch: {
    filterForm: {
      handler() {
        this.getCiExecute();
      },
      immediate: true, // 立即执行一次
      deep: true
    }
  },
  methods: {
    getCiExecute() {
      this.executeDatas = null;
      getCiExecuteData({ ...this.filterForm }).then(
        res => {
          this.executeDatas = res.data.items;
        }
      );
    }
  }
};
</script>
<style>
.customer-col {
    margin-top: 16px;
}
</style>
